export default __webpack_public_path__ + "static/media/szpital.ca687912.png";